module.exports = __webpack_public_path__ + "img/zdll.be3ce184.png";